import { render, staticRenderFns } from "./ListItemNoti.vue?vue&type=template&id=3b4df200&scoped=true&"
import script from "./ListItemNoti.vue?vue&type=script&lang=js&"
export * from "./ListItemNoti.vue?vue&type=script&lang=js&"
import style0 from "./ListItemNoti.vue?vue&type=style&index=0&id=3b4df200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4df200",
  null
  
)

export default component.exports